export default "__VITE_ASSET__B2wh0sMY__"